import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19864347"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content_list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "wl" }
const _hoisted_6 = { class: "content_list_item_name" }

import { onMounted, ref, reactive, watch } from 'vue'
    import { getListByWarehouseId } from '@/apis/WorkOrderAPI'
    import { model } from '@/interface'
    import { judgmentPlatform } from "@/utils/utils"

    // 搜索数据接口
    interface form extends model {
        total: number,
        smodelLabel: string,
        categoryId: string
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
        show: {     // 是否显示
            type: Boolean,
            required: true
        },
        warehouseId: {   // 仓库编码
            type: String,
            required: false
        }
    },
  emits: ['close', 'value'],
  setup(__props, { emit }) {

const props = __props

    const form = reactive<form>({
        capacity: 50,
        page: 0,
        total: 0,
        smodelLabel: '',
        categoryId: ''
    })

    // 列表数据
    const list: any = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false)
    let isOne = ref<boolean>(true)
    let isOpen = ref<boolean>(true)

    const test = () => {
        form.smodelLabel = ''
    }

    const clickTag = (tag: string): void => {
        form.categoryId = tag
        list.value = []
        finished.value = false
        form.page = 0
        form.total = 0
        onLoad()
    }

    // 搜索框
    const searchInput = (data: any) => {
        console.log(data)
        form.page = 0
        finished.value = false
        list.value = []
        form.smodelLabel = data
        onLoad()
    }

    // 搜索提交
    const submit = (): void => {
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 返回上一页带参数
    const jump = (item: any, i: number): void => {
        // list.value.splice(i, 1)
        emit('value', item, list.value.length)
    }

    // 获取工单列表数据
    const onLoad = async () => {
        if (!finished.value) {
            loading.value = true;
            form.page = form.page + 1
            getListByWarehouseId({
                wareHouseId: props.warehouseId
            }).then(res => {
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
                loading.value = false;
                finished.value = true;
                if (res.code === 200 && res.data && res.data.length !== 0) {
                    list.value.push(...res.data)
                }
            }).catch((err: any) => {
                loading.value = false;
                finished.value = true;
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        form.page = 0
        loading.value = true;
        onLoad()
    }

    let status = ref<boolean>(false)

    

    

    // 关闭回调
    const close = () => {
        emit('close')
    }

    watch(() => props.show, (news) => {
        if (!news) {
            test()
        } else {
            if (!isOpen.value) {
                list.value = []
                finished.value = false;
                form.page = 0
                loading.value = true;
                onLoad()
            }
            isOpen.value = false
        }
    })

    onMounted(() => {
        status.value = judgmentPlatform()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: props.show,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((props.show) = $event)),
    position: "bottom",
    round: "",
    style: { height: '50%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "close",
          onClick: close
        }, [
          _createVNode(_component_van_icon, {
            name: "arrow-down",
            size: "30",
            color: "#ffffff"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_pull_refresh, {
          modelValue: refreshing.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
          onRefresh: onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_list, {
              loading: loading.value,
              "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了~",
              onLoad: onLoad
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "content_list_item",
                      key: i,
                      onClick: ($event: any) => (jump(item, i))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, "入库货位：" + _toDisplayString(item.unionName) + " | " + _toDisplayString(item.code), 1)
                      ])
                    ], 8, _hoisted_4))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["loading", "finished"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})